import { GET_TRYST_HOST } from "../constants/env";
import fetch from "../fetch-client";
import { TrystGenericResponse } from "../types/tryst";

export default async function sendBusinessAppointmentReminder({
  aid,
}: {
  aid: string;
}): Promise<TrystGenericResponse<{}>> {
  try {
    const TRYST_HOST = GET_TRYST_HOST();

    let endpoint = `${TRYST_HOST}/business/appointment/${aid}/send-reminder`;

    const res = await fetch(endpoint, {
      method: "GET",
      credentials: "include",
    });

    return res.json();
  } catch (e) {
    return { success: false, error: "Failed to send appointment reminder" };
  }
}
